import React, {ReactNode} from "react";
import {AnnotationProperties, SVG_NAMESPACE} from "../Annotation";
import FunctionHelper from "../../helper/FunctionHelper";
import PortalPureComponent from "../../components/PortalPureComponent";

export class NoteIcon extends PortalPureComponent<AnnotationProperties> {
	/**
	 * render component as react node
	 */
	public render(): ReactNode {
		return (
			<svg xmlns={SVG_NAMESPACE} width={this.props.width} height={this.props.height} viewBox="0 0 40 40"
				 style={{
					 opacity: FunctionHelper.applyValue(this.props.opacity, 1),
					 transform: "rotate(" + FunctionHelper.applyValue(this.props.rotation, 0) + "deg)",
				 }}>
				<rect width="36" height="31" x="2" y="4.5"
					  style={{
						  fill: this.props.color,
						  fillOpacity: 0.5,
						  fillRule: "evenodd",
						  stroke: "#000000",
						  strokeWidth: 1.23004246,
						  strokeOpacity: 1
					  }}/>
				<rect width="28" height="1" x="6" y="10"
					  style={{
						  fill: "#000000",
						  fillOpacity: 1,
						  stroke: "none"
					  }}/>
				<rect width="28" height="1" x="6" y="16"
					  style={{
						  fill: "#000000",
						  fillOpacity: 1,
						  stroke: "none"
					  }}/>
				<rect width="28" height="1" x="6" y="22"
					  style={{
						  fill: "#000000",
						  fillOpacity: 1,
						  stroke: "none"
					  }}/>
				<rect width="28" height="1" x="6" y="28"
					  style={{
						  fill: "#000000",
						  fillOpacity: 1,
						  stroke: "none"
					  }}/>
			</svg>
		);
	}
}